module.exports = __webpack_public_path__ + "static/media/3.21245243.jpg";